var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app-main-content" }, [
    _c(
      "div",
      {
        staticClass: "app-main-inner-row",
        staticStyle: {
          "padding-top": "0",
          width: "1200px",
          height: "500px",
          "background-color": "#ffffff"
        }
      },
      [
        _c(
          "el-form",
          {
            staticStyle: { width: "400px" },
            attrs: {
              "label-width": _vm.$selectByLang("90px", "110px"),
              "label-position": "left"
            }
          },
          [
            _c(
              "div",
              { staticClass: "el-form-item-wrapper" },
              [
                _c(
                  "el-form-item",
                  {
                    attrs: { label: _vm.$t("Invoice.invoice_invoicingMethod") }
                  },
                  [
                    _c("span", { staticStyle: { "font-size": "14px" } }, [
                      _vm._v(_vm._s(_vm.invoicingMethod))
                    ])
                  ]
                ),
                _c(
                  "el-form-item",
                  [
                    _c("line-label", {
                      attrs: {
                        slot: "label",
                        label: _vm.isCollectInvoice
                          ? _vm.$t("Invoice.invoice_CollectInvoiceType")
                          : _vm.$t("Invoice.invoice_invoicingType")
                      },
                      slot: "label"
                    }),
                    _c(
                      "el-radio-group",
                      {
                        staticClass: "custom-radio-group",
                        attrs: { no: "typeGroup" },
                        model: {
                          value: _vm.properties.typeGroup,
                          callback: function($$v) {
                            _vm.$set(_vm.properties, "typeGroup", $$v)
                          },
                          expression: "properties.typeGroup"
                        }
                      },
                      [
                        _c(
                          "el-radio",
                          {
                            attrs: {
                              label: "multi",
                              disabled: _vm.properties.isHedge
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.isCollectInvoice
                                  ? _vm.$t(
                                      "Invoice.invoice_consolidatedInvoiceCollect"
                                    )
                                  : _vm.$t(
                                      "Invoice.invoice_consolidatedInvoice"
                                    )
                              )
                            )
                          ]
                        ),
                        _c(
                          "el-radio",
                          {
                            attrs: {
                              label: "settlementAgent",
                              disabled:
                                _vm.properties.isHedge ||
                                _vm.properties.toExoSystemHC
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.isCollectInvoice
                                  ? _vm.$t(
                                      "Invoice.invoice_invoicingAccordingToSettlementAgentCollect"
                                    )
                                  : _vm.$t(
                                      "Invoice.invoice_invoicingAccordingToSettlementAgent"
                                    )
                              )
                            )
                          ]
                        ),
                        _c(
                          "el-radio",
                          {
                            attrs: {
                              label: "job",
                              disabled:
                                _vm.properties.isHedge ||
                                _vm.properties.toExoSystemHC
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.isCollectInvoice
                                  ? _vm.$t(
                                      "Invoice.invoice_invoicingAccordingToBusinessCollect"
                                    )
                                  : _vm.$t(
                                      "Invoice.invoice_invoicingAccordingToBusiness"
                                    )
                              )
                            )
                          ]
                        ),
                        _c(
                          "el-radio",
                          {
                            attrs: {
                              label: "single",
                              disabled:
                                _vm.properties.isHedge ||
                                (_vm.properties.toExoSystemHC &&
                                  !_vm.properties.isAr)
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.isCollectInvoice
                                  ? _vm.$t(
                                      "Invoice.invoice_invoicingAccordingToRecordsCollect"
                                    )
                                  : _vm.$t(
                                      "Invoice.invoice_invoicingAccordingToRecords"
                                    )
                              )
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: _vm.$t("Invoice.invoice_makeType") } },
                  [
                    _c(
                      "el-radio-group",
                      {
                        attrs: { no: "groupingMakeType" },
                        on: { change: _vm.changeInvoiceType },
                        model: {
                          value: _vm.properties.groupingMakeType,
                          callback: function($$v) {
                            _vm.$set(_vm.properties, "groupingMakeType", $$v)
                          },
                          expression: "properties.groupingMakeType"
                        }
                      },
                      [
                        _c(
                          "el-radio",
                          {
                            attrs: {
                              label: 0,
                              disabled:
                                _vm.properties.invoiceType === 6 ||
                                _vm.properties.invoiceType === 7 ||
                                _vm.properties.isEasyInoivceVietnam
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("Invoice.invoice_makePaper")))]
                        ),
                        _c(
                          "el-radio",
                          {
                            attrs: {
                              label: 1,
                              disabled:
                                _vm.properties.invoiceType !== 2 &&
                                _vm.properties.invoiceType !== 3
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("Invoice.invoice_makeElectronic"))
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: _vm.$t("Invoice.invoice_invoiceType") } },
                  [
                    _c(
                      "el-select",
                      {
                        staticStyle: { width: "175px" },
                        attrs: { no: "invoiceType" },
                        on: { change: _vm.invoiceTypeChange },
                        model: {
                          value: _vm.properties.invoiceType,
                          callback: function($$v) {
                            _vm.$set(_vm.properties, "invoiceType", $$v)
                          },
                          expression: "properties.invoiceType"
                        }
                      },
                      _vm._l(
                        _vm.isFei
                          ? _vm.InvoiceConstant.INVOICE_TYPES_FEI
                          : _vm.InvoiceConstant.INVOICE_TYPES,
                        function(item) {
                          return _c("el-option", {
                            key: item.code,
                            attrs: {
                              label:
                                _vm.$store.getters.language === "zh"
                                  ? item.chineseName
                                  : item.englishName,
                              value: item.code
                            }
                          })
                        }
                      ),
                      1
                    )
                  ],
                  1
                ),
                _vm.properties.invoiceType === 6 ||
                _vm.properties.invoiceType === 7
                  ? _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("Invoice.SpecificConstraintTypes")
                        }
                      },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "175px" },
                            attrs: { disabled: _vm.restrictionHC },
                            model: {
                              value: _vm.properties.specificConstraintType,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.properties,
                                  "specificConstraintType",
                                  $$v
                                )
                              },
                              expression: "properties.specificConstraintType"
                            }
                          },
                          _vm._l(
                            _vm.InvoiceConstant.SPECIFIC_CONSTRAINT_TYPES,
                            function(item) {
                              return _c("el-option", {
                                key: item.code,
                                attrs: {
                                  label:
                                    _vm.$store.getters.language === "zh"
                                      ? item.chineseName
                                      : item.englishName,
                                  value: item.code
                                }
                              })
                            }
                          ),
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _c(
                  "el-form-item",
                  [
                    _c("line-label", {
                      attrs: {
                        slot: "label",
                        label: _vm.isCollectInvoice
                          ? _vm.$t(
                              "Invoice.invoice_invoicingAccordingToCurrencyCollect"
                            )
                          : _vm.$t(
                              "Invoice.invoice_invoicingAccordingToCurrency"
                            )
                      },
                      slot: "label"
                    }),
                    _c(
                      "el-radio-group",
                      {
                        attrs: { no: "currencyGroup" },
                        model: {
                          value: _vm.properties.currencyGroup,
                          callback: function($$v) {
                            _vm.$set(_vm.properties, "currencyGroup", $$v)
                          },
                          expression: "properties.currencyGroup"
                        }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "inlineWarp",
                            staticStyle: { "margin-bottom": "10px" }
                          },
                          [
                            _c(
                              "el-radio",
                              {
                                attrs: { no: "invoicingPerCurrency", label: 0 }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.isCollectInvoice
                                      ? _vm.$t(
                                          "Invoice.invoice_invoicingPerCurrencyCollect"
                                        )
                                      : _vm.$t(
                                          "Invoice.invoice_invoicingPerCurrency"
                                        )
                                  )
                                )
                              ]
                            ),
                            _c(
                              "el-checkbox",
                              {
                                attrs: {
                                  disabled: _vm.properties.currencyGroup === 1,
                                  no: "cbAssignCurrency"
                                },
                                model: {
                                  value: _vm.properties.cbAssignCurrency,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.properties,
                                      "cbAssignCurrency",
                                      $$v
                                    )
                                  },
                                  expression: "properties.cbAssignCurrency"
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "Invoice.invoice_specifyInvoiceCurrency"
                                    )
                                  )
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        !_vm.properties.settlementCenterMode
                          ? _c(
                              "el-radio",
                              {
                                attrs: {
                                  no: "consolidatedCurrency",
                                  label: 1,
                                  disabled: _vm.properties.isEasyInoivceVietnam
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "Invoice.invoice_consolidatedCurrency"
                                    )
                                  )
                                )
                              ]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  [
                    _c("line-label", {
                      attrs: {
                        slot: "label",
                        label: _vm.isCollectInvoice
                          ? _vm.$t("Invoice.invoice_invoicingCurrencyCollect")
                          : _vm.$t("Invoice.invoice_invoicingCurrency")
                      },
                      slot: "label"
                    }),
                    _c("cargo-advance-select", {
                      staticStyle: { width: "175px" },
                      attrs: {
                        no: "currency",
                        filterable: "",
                        "select-type": _vm.TYPE_NAMES.basic_data_Currency,
                        "default-value": _vm.properties.currency,
                        clearable: false,
                        disabled:
                          _vm.properties.allowModifyCurrency === false ||
                          !(
                            (_vm.properties.currencyGroup === 0 &&
                              _vm.properties.cbAssignCurrency) ||
                            _vm.properties.currencyGroup === 1
                          )
                      },
                      on: { parentCallBack: _vm.currencyChangeEvent }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  [
                    _c("line-label", {
                      attrs: {
                        slot: "label",
                        label: _vm.$t("Invoice.invoice_settleDepartmentPrefix")
                      },
                      slot: "label"
                    }),
                    _c("cargo-department-select", {
                      staticStyle: { width: "175px" },
                      attrs: {
                        no: "settleDepartment",
                        "office-id": Number(_vm.$store.getters.currentOfficeId),
                        "department-id": Number(_vm.properties.settleDepartment)
                      },
                      on: { change: _vm.settleDepartmentChangeEvent }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.$checkPermission([
                          "button_ACInvoice_autoCheckInvoicing"
                        ]),
                        expression:
                          "$checkPermission(['button_ACInvoice_autoCheckInvoicing'])"
                      }
                    ],
                    attrs: { "label-width": "0" }
                  },
                  [
                    _c("div", { staticStyle: { display: "flex" } }, [
                      _c("span", [
                        _vm._v(_vm._s(_vm.$t("Invoice.UseAutoCheckInvoicing")))
                      ]),
                      _c(
                        "div",
                        { staticStyle: { "padding-left": "10px" } },
                        [
                          _c(
                            "el-radio",
                            {
                              attrs: { no: "yes", label: true },
                              model: {
                                value: _vm.properties.useAutoCheckInvoicing,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.properties,
                                    "useAutoCheckInvoicing",
                                    $$v
                                  )
                                },
                                expression: "properties.useAutoCheckInvoicing"
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Yes")))]
                          ),
                          _c(
                            "el-radio",
                            {
                              attrs: {
                                no: "no",
                                label: false,
                                disabled:
                                  _vm.properties.autoCheckInvoiceAmountEnable
                              },
                              model: {
                                value: _vm.properties.useAutoCheckInvoicing,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.properties,
                                    "useAutoCheckInvoicing",
                                    $$v
                                  )
                                },
                                expression: "properties.useAutoCheckInvoicing"
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_No")))]
                          )
                        ],
                        1
                      )
                    ])
                  ]
                ),
                _c(
                  "el-form-item",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.properties.useAutoCheckInvoicing &&
                          _vm.$checkPermission([
                            "button_ACInvoice_autoCheckInvoicing"
                          ]),
                        expression:
                          "properties.useAutoCheckInvoicing && $checkPermission(['button_ACInvoice_autoCheckInvoicing'])"
                      }
                    ],
                    attrs: { "label-width": "0" }
                  },
                  [
                    _c(
                      "div",
                      { staticStyle: { display: "flex" } },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm.$t("Invoice.DefaultInvoicingAmount"))
                          )
                        ]),
                        _c("el-input-number", {
                          staticStyle: { "padding-left": "10px" },
                          attrs: {
                            no: "autoCheckInvoicingAmount",
                            disabled:
                              _vm.properties.autoCheckInvoiceAmountEnable,
                            controls: false,
                            min: 0,
                            precision: 2
                          },
                          model: {
                            value: _vm.properties.autoCheckInvoicingAmount,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.properties,
                                "autoCheckInvoicingAmount",
                                $$v
                              )
                            },
                            expression: "properties.autoCheckInvoicingAmount"
                          }
                        })
                      ],
                      1
                    )
                  ]
                ),
                _c(
                  "el-form-item",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.properties.isAr,
                        expression: "properties.isAr"
                      }
                    ],
                    attrs: { "label-width": "0" }
                  },
                  [
                    _c(
                      "el-checkbox",
                      {
                        attrs: {
                          no: "showChargeDetail",
                          disabled: !_vm.properties.showChargeDetailByInvoice
                        },
                        model: {
                          value: _vm.properties.showChargeDetail,
                          callback: function($$v) {
                            _vm.$set(_vm.properties, "showChargeDetail", $$v)
                          },
                          expression: "properties.showChargeDetail"
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.$t("Invoice.invoice_showChargeDetails"))
                        )
                      ]
                    ),
                    _vm.properties.isEasyInoivceVietnam
                      ? _c(
                          "el-checkbox",
                          {
                            attrs: { no: "isInvoicingByTaxRate" },
                            model: {
                              value: _vm.properties.isInvoicingByTaxRate,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.properties,
                                  "isInvoicingByTaxRate",
                                  $$v
                                )
                              },
                              expression: "properties.isInvoicingByTaxRate"
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t("CargoMsg.Cargo_InvoicingByTaxRate")
                              )
                            )
                          ]
                        )
                      : _vm._e()
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { "label-width": "0" } },
                  [
                    _c(
                      "el-checkbox",
                      {
                        attrs: { no: "useDefaultRate" },
                        model: {
                          value: _vm.properties.useDefaultRate,
                          callback: function($$v) {
                            _vm.$set(_vm.properties, "useDefaultRate", $$v)
                          },
                          expression: "properties.useDefaultRate"
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.isCollectInvoice
                              ? _vm.$t(
                                  "Invoice.invoice_invoicingAccordingToFinancialExchangeRateCollect"
                                )
                              : _vm.$t(
                                  "Invoice.invoice_invoicingAccordingToFinancialExchangeRate"
                                )
                          )
                        )
                      ]
                    ),
                    _c(
                      "el-checkbox",
                      {
                        attrs: {
                          no: "isInvoicingByBillingRate",
                          disabled: !_vm.invoicingByBillingRate
                        },
                        model: {
                          value: _vm.properties.isInvoicingByBillingRate,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.properties,
                              "isInvoicingByBillingRate",
                              $$v
                            )
                          },
                          expression: "properties.isInvoicingByBillingRate"
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.isCollectInvoice
                              ? _vm.$t(
                                  "Invoice.invoice_invoicingAccordingByBillingExchangeRateCollect"
                                )
                              : _vm.$t(
                                  "Invoice.invoice_invoicingAccordingByBillingExchangeRate"
                                )
                          )
                        )
                      ]
                    )
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.properties.isAr,
                        expression: "properties.isAr"
                      }
                    ],
                    attrs: { "label-width": "0" }
                  },
                  [
                    _c(
                      "el-checkbox",
                      {
                        attrs: {
                          no: "makeCostInvoice",
                          disabled: _vm.properties.isEasyInoivceVietnam
                        },
                        model: {
                          value: _vm.properties.makeCostInvoice,
                          callback: function($$v) {
                            _vm.$set(_vm.properties, "makeCostInvoice", $$v)
                          },
                          expression: "properties.makeCostInvoice"
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.$t("Invoice.invoice_generateCostInvoice"))
                        )
                      ]
                    ),
                    _vm.properties.isBillPreInvoicing &&
                    _vm.properties.makeInvoiceMethod === 3
                      ? _c(
                          "el-checkbox",
                          {
                            attrs: { no: "billPreInvoicing" },
                            model: {
                              value: _vm.properties.billPreInvoicing,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.properties,
                                  "billPreInvoicing",
                                  $$v
                                )
                              },
                              expression: "properties.billPreInvoicing"
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_billingTip")))]
                        )
                      : _vm._e()
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.properties.isAr,
                        expression: "!properties.isAr"
                      }
                    ],
                    attrs: { "label-width": "0" }
                  },
                  [
                    _c(
                      "el-checkbox",
                      {
                        attrs: {
                          no: "isInvoicingByBusinessDateRate",
                          disabled: _vm.invoicingByBusinessDateEnable
                        },
                        model: {
                          value: _vm.properties.isInvoicingByBusinessDateRate,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.properties,
                              "isInvoicingByBusinessDateRate",
                              $$v
                            )
                          },
                          expression: "properties.isInvoicingByBusinessDateRate"
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.isCollectInvoice
                              ? _vm.$t(
                                  "Invoice.InvoicingByBusinessDateExchangeRateCollect"
                                )
                              : _vm.$t(
                                  "Invoice.InvoicingByBusinessDateExchangeRate"
                                )
                          )
                        )
                      ]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ]
        ),
        _c(
          "div",
          { staticStyle: { width: "640px" } },
          [
            _c("div", { staticClass: "app-main-inner-row" }, [
              _c("span", { staticStyle: { "font-size": "14px" } }, [
                _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_InvoiceItemNameSetup")))
              ])
            ]),
            _c("div", { staticClass: "app-main-inner-row" }, [
              _c(
                "div",
                { staticClass: "triggers" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", no: "toAdd" },
                      on: { click: _vm.toAdd }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.new")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        no: "toEdit",
                        disabled: _vm.isEditing
                      },
                      on: { click: _vm.toEdit }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.edit")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "danger",
                        no: "toDelete",
                        disabled: _vm.isEditing
                      },
                      on: { click: _vm.toDelete }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.delete")))]
                  ),
                  _c(
                    "el-button",
                    {
                      style: _vm.$selectByLang("", "margin-top: 5px;"),
                      attrs: {
                        type: "primary",
                        no: "doDefaultSetting",
                        disabled: _vm.isEditing
                      },
                      on: { click: _vm.doDefaultSetting }
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.$t("CargoMsg.Cargo_SetDefaultItemDescription")
                        )
                      )
                    ]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        no: "needSave",
                        disabled: !_vm.needSave
                      },
                      on: { click: _vm.toSave }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.save")))]
                  ),
                  _vm.properties.isEasyInoivceVietnam
                    ? _c(
                        "el-dropdown",
                        {
                          staticStyle: { "padding-left": "5px" },
                          attrs: { "split-button": "", type: "primary" },
                          on: {
                            click: function($event) {
                              return _vm.btnSetupHandler()
                            },
                            command: function(p) {
                              _vm.commandCode = p
                              _vm.btnSetupHandler()
                            }
                          }
                        },
                        [
                          _vm._v(" " + _vm._s(_vm.commandCode) + " "),
                          _c(
                            "el-dropdown-menu",
                            { attrs: { slot: "dropdown" }, slot: "dropdown" },
                            [
                              _c(
                                "el-dropdown-item",
                                {
                                  attrs: {
                                    command: _vm.$t(
                                      "CargoMsg.Cargo_InvoiceChargeItemSetup"
                                    ),
                                    no: "invoiceChargeItemSetup"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "CargoMsg.Cargo_InvoiceChargeItemSetup"
                                      )
                                    )
                                  )
                                ]
                              ),
                              _c(
                                "el-dropdown-item",
                                {
                                  attrs: {
                                    command: _vm.$t(
                                      "CargoMsg.Cargo_InvoiceChargeUnitSetup"
                                    ),
                                    no: "invoiceChargeUnitSetup"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "CargoMsg.Cargo_InvoiceChargeUnitSetup"
                                      )
                                    )
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ]),
            _c(
              "div",
              {
                staticClass: "app-main-inner-row row-grid",
                staticStyle: {
                  height: "260px",
                  "padding-left": "10px",
                  "padding-right": "6px"
                }
              },
              [
                _c("cargo-ag-grid", {
                  staticStyle: { width: "100%", flex: "1" },
                  attrs: {
                    "config-module": "20220416",
                    "grid-params": _vm.invoiceGoodsName.gridParams,
                    "grid-options": _vm.invoiceGoodsName.gridOptions,
                    "column-defs": _vm.invoiceGoodsNameColumnDefs,
                    "row-data": _vm.invoiceGoodsNameRowData
                  },
                  on: {
                    "update:gridParams": function($event) {
                      return _vm.$set(
                        _vm.invoiceGoodsName,
                        "gridParams",
                        $event
                      )
                    },
                    "update:grid-params": function($event) {
                      return _vm.$set(
                        _vm.invoiceGoodsName,
                        "gridParams",
                        $event
                      )
                    },
                    gridReady: function(params) {
                      return (_vm.gridApi = params.api)
                    }
                  }
                })
              ],
              1
            ),
            _c(
              "span",
              {
                staticStyle: {
                  color: "red",
                  "padding-left": "10px",
                  "padding-right": "6px"
                }
              },
              [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_TaxRevenueToolTip")))]
            ),
            _c(
              "el-form",
              {
                staticStyle: { width: "400px" },
                attrs: { "label-width": "80px", "label-position": "right" }
              },
              [
                _c(
                  "div",
                  { staticStyle: { display: "flex" } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("CargoMsg.Cargo_Payee") } },
                      [
                        _c("el-input", {
                          staticStyle: { width: "100px" },
                          attrs: { no: "payee" },
                          model: {
                            value: _vm.properties.payee,
                            callback: function($$v) {
                              _vm.$set(_vm.properties, "payee", $$v)
                            },
                            expression: "properties.payee"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("CargoMsg.Cargo_Recheck") } },
                      [
                        _c("el-input", {
                          staticStyle: { width: "100px" },
                          attrs: { no: "auditor" },
                          model: {
                            value: _vm.properties.auditor,
                            callback: function($$v) {
                              _vm.$set(_vm.properties, "auditor", $$v)
                            },
                            expression: "properties.auditor"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("CargoMsg.Cargo_InvoicedBy") } },
                      [
                        _c("cargo-user-select", {
                          staticStyle: { width: "100px" },
                          attrs: {
                            no: "autoInputBy",
                            "method-params": {
                              officeId: _vm.$store.getters.currentOfficeId
                            },
                            "default-value": _vm.properties.autoInputBy || ""
                          },
                          on: {
                            change: function(p) {
                              _vm.properties.autoInputBy = p.value
                            }
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticStyle: { "padding-left": "10px" } },
                  [
                    _c(
                      "el-checkbox",
                      {
                        attrs: { no: "applyRuleToAll" },
                        on: { change: _vm.applyRuleToAllChangeHandler },
                        model: {
                          value: _vm.applyRuleToAll,
                          callback: function($$v) {
                            _vm.applyRuleToAll = $$v
                          },
                          expression: "applyRuleToAll"
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$t("CargoMsg.Cargo_ApplyRuleToAllScenarios")
                          )
                        )
                      ]
                    )
                  ],
                  1
                )
              ]
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }